import React from 'react';
import useStyles from './useStyles';
import { clsx } from '@components/Provider';
import { DefaultThumbnail } from '@assets';

interface Props
  extends React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  index?: number;
  matches: boolean;
  mode: 'preview' | 'more';
  max?: number;
  multipleImages?: boolean;
  gutterBottom?: boolean;
}

const ReviewImage = ({
  src,
  mode,
  matches,
  index,
  max = 0,
  multipleImages,
  gutterBottom = false,
  onClick,
  ...rest
}: Props) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.image, {
        'image-preview': mode === 'preview',
        'image-more': mode === 'more',
        'image-gutterBottom': gutterBottom,
        'image-gutterTop': index === 0,
        'cursor': !matches
      })}
    >
      <img
        className={clsx({
          more: mode === 'more'
        })}
        src={src}
        onError={(e) => (e.currentTarget.src = DefaultThumbnail)}
        alt=""
        onClick={onClick}
        {...rest}
      />

      {mode === 'preview' && (
        <>
          {matches && rest.className === 'right__radius' && max > 1 && (
            <div onClick={onClick} className="right__overlay">
              <span>+{max - 1}</span>
            </div>
          )}

          {!matches && max > 1 && (
            <div className="bottom__count">
              <span>{max ? max : ''}</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ReviewImage;
